import moment from "moment";
import { VALID_PAY_FREQUENCIES, normalizeFrequency } from "./CalculateMonthlyPay";

interface payRecords {
    is_Duplicate: number;
    Pay_frequency: any;
    End_date?: any;
    Start_date?: any;
}

const DATE_FORMATS = ["YYYY-MM-DD", "YYYY-M-D", "MM/DD/YYYY", "M/D/YYYY"];
const acceptedFrequencies = new Set<string>(Object.values(VALID_PAY_FREQUENCIES));

const hasUsablePayPeriodDates = (startDate?: any, endDate?: any): boolean => {
    const start = moment(startDate, DATE_FORMATS, true);
    const end = moment(endDate, DATE_FORMATS, true);
    return start.isValid() && end.isValid() && !start.isAfter(end);
}

const AvgPay = (totalNetPay, payRecords: payRecords[]) => {
    if (totalNetPay === 0) return 0;
    if (!payRecords.length) return 0;
    const payRecordsWithoutDuplicate = payRecords.filter((file) => file.is_Duplicate === 0);
    const payRecordsWithValidPayFrequency = payRecordsWithoutDuplicate.filter((file) => {
        const frequency = normalizeFrequency(file.Pay_frequency?.value);
        if (!acceptedFrequencies.has(frequency)) return false;
        if (!file.Start_date || !file.End_date) return false;
        return hasUsablePayPeriodDates(file.Start_date, file.End_date);
    });
    const uniqueDateRecords = payRecordsWithValidPayFrequency.filter((record, index, self) =>
        index === self.findIndex((r) => 
            r.Start_date === record.Start_date && 
            r.End_date === record.End_date
        )
    );
    if (!uniqueDateRecords.length) return totalNetPay;

    return totalNetPay / uniqueDateRecords.length;
}

export default AvgPay;
